<template lang="pug">
b-modal(:visible="showModal" @change="$emit('update:showModal', $event)" :title="isAcknowledgment ? 'Create New Acknowledgment' : 'Create New Subscription Package'" size="lg" no-close-on-backdrop)
    form(@submit.prevent="handleSubmit")
        div(class="form-row")
            div(class="form-group col-md-6")
                label {{ isAcknowledgment ? 'Acknowledgment Name' : 'Subscription Name' }}
                b-form-input(v-model="form.name" :placeholder="isAcknowledgment ? 'e.g., Completion Certificate' : 'e.g., Neurofit Monthly Subscription'" required)
            div(class="form-group col-md-6" v-if="!isAcknowledgment")
                label Price ($)
                b-form-input(type="number" v-model="form.price" min="0" :required="!isAcknowledgment")
            div(class="form-group col-md-6" v-if="!isAcknowledgment")
                label GST (%) 
                b-form-input(type="number" v-model="form.gst" min="0" max="100" step="0.01" placeholder="e.g., 10" required)
        div(class="form-group")
            label Description
            VueEditor(v-model="form.description" :editorToolbar="customToolbar" placeholder="Enter Body" required)
        div(class="form-row")
            div(class="form-group col-md-6")
                label Start Date
                b-form-input(type="date" v-model="form.startDate" required)
            div(class="form-group col-md-6")
                label End Date
                b-form-input(type="date" v-model="form.endDate" required)
        div(class="form-group" v-if="form.startDate && form.endDate")
            p Selected Duration:  {{ form.startDate && form.endDate ? Math.round(((new Date(form.endDate) - new Date(form.startDate)) / (1000 * 60 * 60 * 24)) / 30) + ' months' : 'N/A' }} or {{ form.startDate && form.endDate ? ((new Date(form.endDate) - new Date(form.startDate)) / (1000 * 60 * 60 * 24)) + ' days' : 'N/A' }} 
        //- div(class="form-group" v-if="!isAcknowledgment")
        //-     b-form-checkbox(v-model="form.active" switch) Active Package
        b-form-group(label="Only Clients" class="mt-3")
            b-form-checkbox(v-model="form.isClients" switch)
        b-form-group(label v-if="!form.isClients") 
            label Assign to Groups
            v-select( id="event-group"  :options="groups" :reduce="item => ({ id: item.id, name: item.name })" multiple label="name" placeholder="Select Group" :class="{'invalid': form.groups && form.groups.length === 0}" v-model="form.groups")
        
        b-form-group(label="Clients" v-if="form.isClients")
             v-select(
                class="w-100"
                v-model="form.selectedClients"
                :options="searchedClients"
                :loading="loadingSearch"
                :filterable="false"
                @search="search"
                :multiple="true"
                label="name"
                track-by="id"
                :reduce="option => option"
                )
                    template(#no-options)
                        p Type to search users by name
                    template(#option="option")
                        div {{ option.name }}
                    template(#selected-option="option")
                        div {{ option.name }}
        div(class="form-group" v-if="error")
            b-alert(type="danger" dismissible) {{ error }}
    template(v-slot:modal-footer)
        b-button(@click="closeModal" variant="secondary") Cancel
        b-button(type="submit" variant="dark" :disabled="loading" @click="handleSubmit")
            | {{ loading ? 'Creating...' : (isAcknowledgment ? 'Create Acknowledgment' : 'Create Package') }}
</template>

<script>
import { BModal, BFormInput, BFormTextarea, BFormCheckbox, BButton, BAlert, BFormGroup } from 'bootstrap-vue';
import axios from 'axios';
import debounce from 'lodash.debounce';
import { VueEditor } from "vue2-editor";

export default {
    components: {
        BModal,
        BFormInput,
        BFormTextarea,
        BFormCheckbox,
        BButton,
        BAlert,
        BFormGroup,
        VueEditor
    },
    props: {
        showModal: {
            type: Boolean,
            required: true
        },
        groups: {
            type: Array,
            default: () => []
        },
        isAcknowledgment: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            customToolbar: [
                ["bold", "italic", "underline"],
                [{ list: "ordered" }, { list: "bullet" }],
                [
                    { align: "" },
                    { align: "center" },
                    { align: "right" },
                    { align: "justify" },
                ],
                ["link"],
                ["clean"],
            ],
            form: {
                name: '',
                price: '',
                description: '',
                startDate: '',
                endDate: '',
                active: false,
                groups: [],
                isClients: false,
                selectedClients: [],
                gst: 9
            },
            loading: false,
            error: '',
            searchedClients: [],
            loadingSearch: false
        }
    },
    methods: {
        search: debounce(async function(query) {
            if (!query || query.length < 2) {
                this.searchedClients = [];
                return;
            }
            
            this.loadingSearch = true;
            try {
                const res = await axios.post(`/api/announcement/v2/searchClient?search=${encodeURIComponent(query)}`, {
                    search: query,
                });
                console.log(res.data);
                if (res.status === 200) {
                    this.searchedClients = res.data?.clients || [];
                    console.log(this.searchedClients);
                }
            } catch (error) {
                console.error(error);
                this.$root.$bvToast.toast("An error occurred while searching for clients", {
                    title: "Error",
                    variant: "danger",
                    solid: true,
                });
            } finally {
                this.loadingSearch = false;
            }
        }, 300),
        async handleSubmit() {
            if (this.form.groups.length === 0 && this.form.selectedClients.length === 0) {
                this.error = 'Please select either groups or clients';
                return;
            }
            console.log('Submitting form:', this.form);
            this.loading = true;
            this.error = '';
            try {
                const payload = {
                    crb5c_title: this.form.name,
                    crb5c_description: this.form.description,
                    crb5c_subscriptionname: this.form.name,
                    crb5c_amount: this.isAcknowledgment ? 0 : Number(this.form.price),
                    crb5c_gst: this.isAcknowledgment ? 0 : Number(this.form.gst),
                    crb5c_datefrom: this.form.startDate,
                    crb5c_datetill: this.form.endDate,
                    crb5c_recurring: this.form.active ? true : false,
                    crb5c_groups: this.form.groups.map(group => group.id),
                    crb5c_clients: this.form.selectedClients.map(client => client.id),
                    crb5c_isClients: this.form.isClients
                };
                await axios.post('/api/subscription/create', payload);
                this.$emit('create', { ...this.form });
                this.closeModal();
            } catch (err) {
                this.error = err?.response?.data?.message || 'Failed to create subscription';
            } finally {
                this.loading = false;
            }
        },
        resetForm() {
            this.form = {
                name: '',
                price: '',
                description: '',
                startDate: '',
                endDate: '',
                active: false,
                groups: [],
                isClients: false,
                selectedClients: []
            };
            this.searchedClients = [];
            this.error = '';
        },
        closeModal() {
            this.resetForm();
            this.$emit('update:showModal', false);
        }
    },
    watch: {
        showModal(newVal) {
            if (!newVal) {
                this.resetForm();
            }
        }
    }
}
</script>
